/** Frame kinds used by task and content behavior. Layout does not separate them. */

export const CONTROL_FRAME_TYPES = new Set<string>([
  "taskboard",
  "memory",
  "agent_list",
  "agent_settings",
  "github",
  "conversation",
  "question",
  "connection",
  "connection_prompt",
  "workflow",
]);

export const DELIVERABLE_FRAME_TYPES = new Set<string>([
  "doc",
  "html",
  "code",
  "image",
  "search",
  "email",
  "newsletter",
  "linkedin",
  "event",
  "agenda",
  "flight",
  "weather",
  "chart",
  "dataset",
  "preview_card",
  "link_preview",
  "chat",
  "slack",
  "todo",
  "board",
  "music",
  "calendar",
  "file",
  "terminal",
]);

/** Kinds a user may pin to the Pinned rows (`lib/frame-pinning.ts`). */
export const PINNABLE_FRAME_TYPES = new Set<string>(
  [...CONTROL_FRAME_TYPES, ...DELIVERABLE_FRAME_TYPES].filter(
    (type) =>
      !["conversation", "question", "connection_prompt", "terminal"].includes(
        type,
      ),
  ),
);

export function isControlFrame(type: string): boolean {
  return CONTROL_FRAME_TYPES.has(type);
}

export function isDeliverableFrame(type: string): boolean {
  return DELIVERABLE_FRAME_TYPES.has(type);
}

/** Chats use conversation surfaces; they never participate in Workspace pages. */
export function isWorkspaceFrame(type: string): boolean {
  return type !== "conversation";
}
